import { useI18n } from '../i18n';
import { Link, buildPath, type ModeKey } from '../router';
import type { Lang } from '../lib/countries';

// Daily ⇆ Unlimited 分段开关
export default function ModeToggle({
  lang,
  mode,
  endless,
}: {
  lang: Lang;
  mode: ModeKey;
  endless: boolean;
}) {
  const { t } = useI18n();
  return (
    <div className="mode-toggle" role="group" aria-label="Daily or Unlimited">
      <Link className={!endless ? 'on' : ''} to={buildPath(lang, mode, false)}>
        {t.daily}
      </Link>
      <Link className={endless ? 'on' : ''} to={buildPath(lang, mode, true)}>
        {t.unlimited}
      </Link>
    </div>
  );
}
